<mat-nav-list>
    <a mat-list-item class="sidebar-icon" routerLink="/new" routerLinkActive="active"
       i18n-matTooltip="@@newAsset" matTooltip="new asset" matTooltipPosition="after">
        <mat-icon matListItemIcon>post_add</mat-icon>
    </a>
    <a mat-list-item class="sidebar-icon" routerLink="/assets" routerLinkActive="active"
       i18n-matTooltip="@@assets" matTooltip="assets" matTooltipPosition="after">
        <mat-icon matListItemIcon>library_books</mat-icon>
    </a>
    <a mat-list-item class="sidebar-icon" routerLink="/classes" routerLinkActive="active"
       i18n-matTooltip="@@classes" matTooltip="classes" matTooltipPosition="after">
        <mat-icon matListItemIcon>class</mat-icon>
    </a>
    <a mat-list-item class="sidebar-icon" routerLink="/places" routerLinkActive="active"
       i18n-matTooltip="@@places" matTooltip="places" matTooltipPosition="after">
        <mat-icon matListItemIcon>home_work</mat-icon>
    </a>
    <a mat-list-item class="sidebar-icon" routerLink="/label" routerLinkActive="active"
       i18n-matTooltip="@@printLabel" matTooltip="print label" matTooltipPosition="after">
        <mat-icon matListItemIcon>print</mat-icon>
    </a>
</mat-nav-list>